import React from "react";
import Box from "@mui/material/Box";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const Testimonial1 = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box
      sx={{
        width: 1,

        display: "flex",
        justifyContent: "center",
      }}
    >
      <Fade delay={400}>
        <Box>
          {t("Convenient for cleaning dirt and some germs.")}
          <Box className="normal" sx={{ fontSize: "14px", pt: 1 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "These are excellent to keep on hand with toddlers. <br />There's no alcohol in them."
                ),
              }}
            />
          </Box>
          <Box sx={{ fontSize: "14px", fontWeight: 100, pt: 1, color: "gray" }}>
            Han** {t("Seoul, South Korea")}
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default Testimonial1;
